import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomRight16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconRadiusBottomRight16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.319 12.681h-3a.5.5 0 1 0 0 1h3a5.5 5.5 0 0 0 5.5-5.5v-3a.5.5 0 0 0-1 0v3a4.5 4.5 0 0 1-4.5 4.5m2.612-9.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-3 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-5.75 4.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m.75-2.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m-.75 5.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0m2.75-7.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomRight16);
